<div class="contentContainer">

    <!------------------------------------------------------------------------------ header -->

    <div fxLayout="row" fxLayoutAlign="space-between center" class="headerContentContainer">
        <div fxLayout="row">
            <div fxLayoutAlign="center center" class="grayLink" (click)="routeService.goBack()">
                <mat-icon class="linkIcon ft22">arrow_back</mat-icon>
            </div>
            <div>
                <h6 class="mgl10 ft500 ft16 mgb0 gray-9"> Admins</h6>
            </div>
        </div>
        <div (click)="openUserRoles('')" class="mgl10 sqChip ft12 ft500 backGray9 shadow20">
            Agregar
        </div>
    </div>

    <!------------------------------------------------------------------------------ Table -->

    <div class="tableContainer">

        <table class="fw">

            <!-- Table Header -->
            <tr class="tableHeaderContainer">
                <th>Nombre</th>
                <th>Id</th>
                <th>Email</th>
                <th>Privilegio</th>
            </tr>

            <!-- Table data -->
            <tr *ngFor="let item of array;  let i=index">

                <td>
                    <div fxLayoutAlign="space-between">
                        {{item.nombre}}
                        <div>
                            <mat-icon class="cursorPointer gray-4 ft18 linkIcon" (click)="openUserRoles(item.email)">edit
                            </mat-icon>
                            <mat-icon class="mgl10 cursorPointer red-5 ft18 linkIcon" (click)="eliminarAdmin(item.email)">delete
                            </mat-icon>
                        </div>
                    </div>
                </td>
                <td class="centertext"> {{item.id}}</td>
                <td class="centertext"> {{item.email}}</td>
                <td class="centertext"> {{item.privilegio}}</td>

            </tr>
        </table>

    </div>
</div>